import { Helmet } from 'react-helmet'
import {
  ReconciliationLogExportButton,
  ReconciliationLogTable,
} from 'components/logsReconciliation'

const ReconciliationLog = () => {
  return (
    <>
      <Helmet>
        <title>ORMS ReconciliationLog Logs </title>
      </Helmet>
      <ReconciliationLogExportButton />
      <ReconciliationLogTable />
    </>
  )
}

export default ReconciliationLog
